






















































































































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  PdfFormSignatureModel
} from "@/shared/types";
import moment from "moment";
import * as _ from "lodash";
import { Validator } from "vee-validate";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import Button from "@/shared/components/ui/Button.vue";
import { isMobileApp } from "@/shared/mobileHelper";
import { openDocumentUrl } from "@/shared/urlHelper";

const initialState: PdfFormSignatureModel = {
  documentKey: null,
  captureName: null,
  signatureBase64Image: null,
  signingDate: moment().format("MMMM D, YYYY")
};

@Component({
  components: {
    Button
  }
})
export default class PdfFormSignature extends Vue {
  signingDocument = useSigningDocumentStore();
  $validator: Validator;

  @Prop()
  documentUrl: string;

  @Prop()
  onAccept: (model: PdfFormSignatureModel) => Promise<any>;

  moment = moment;
  isSubmitting = false;
  formModel: PdfFormSignatureModel = { ...initialState };

  atLeastOneAlphabet = {
    getMessage () {
      return "Legal name must contain at least one alphabetical character.";
    },
    validate (value) {
      const allDigits = /^[^A-Z]+$/i; // input lacks any alphabetical characters
      return !allDigits.test(value);
    }
  };

  mounted (): void {
    this.$validator.extend("atLeastOneAlphabet", this.atLeastOneAlphabet);
  }

  onCaptureNameChange () {
    this.generateSignature();
  }

  generateSignature () {
    const canvas = document.createElement("canvas");
    canvas.width = 1200;
    canvas.height = 145;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.scale(3, 3);
    ctx.font = "54px Brush Script MT, Lucida Handwriting";
    ctx.fillStyle = "#000";
    ctx.fillText(this.formModel.captureName, 40, 45, 300);
    this.formModel.signatureBase64Image = canvas.toDataURL("image/png");
  }

  get isSubmitDisabled (): boolean {
    return this.formModel.captureName === null ||
      this.$validator.errors.has("Legal name") ||
      this.isSubmitting ||
      !this.hasDocumentUrl;
  }

  get hasDocumentUrl (): boolean {
    return this.documentUrl && this.documentUrl.length > 0;
  }

  get isMobile (): boolean {
    return isMobileApp();
  }

  goBack (): void {
    this.$emit("back");
  }

  openPdf () {
    openDocumentUrl(this.documentUrl);
  }

  onSubmit (): void {
    if (this.isSubmitting) {
      return;
    }
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.isSubmitting = true;
      return this.onAccept(this.formModel)
      .then(_ => {
        this.isSubmitting = false;
      }).catch(_ => {
        this.isSubmitting = false;
      });
    });
  }
}
